'use strict';

/**
 *
 * @param {string} event -
 * @param {string} location -
 * @param {string } type -
 */
function newsletterSubscriptionTracking(event, location, type) {
    window?.dataLayer?.push({
        event: `${event}`,
        preference: type,
        location: `${location}`
    });
}

module.exports = {
    newsletterSubscriptionTracking
};
